import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

export const ThemeConfigurator = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleToggle = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
  };

  if (!mounted) return null;

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {resolvedTheme === 'light' ? (
        <button
          type="button"
          className="switcher__btn shadow-box"
          onClick={handleToggle}
          aria-label="Switch to dark theme"
        >
          <i className="iconoir-half-moon" aria-hidden="true" />
        </button>
      ) : (
        <button
          type="button"
          className="switcher__btn shadow-box"
          onClick={handleToggle}
          aria-label="Switch to light theme"
        >
          <i className="iconoir-sea-and-sun" aria-hidden="true" />
        </button>
      )}
    </>
  );
};
